export default __webpack_public_path__ + "static/media/masonry.367ea71b.png";